import {IPubCtx} from "lib/wsp/wspMetaUi";
import {SRC} from "lib/wsp/src";
import {ERROR} from "lib/core/errorReport";
import {JSX} from "lib/commons/xml/dom";
import {POPUP} from "back/commons/widgets/popups";
import {GenAction} from "back/wsp/views/gen/genActions";
import {MsgOver} from "back/commons/basis";
import {JSkinPackInstalled} from "lib/wsp/pack";
import {STYLER} from "lib/styler/styler";
import "back/styler/views/views_Perms";

export class StylerInstallSkinsetAction extends GenAction {

	static SINGLETON = new StylerInstallSkinsetAction();

	constructor(id?: string) {
		super(id || "stylerInstallSkinset");
		this._label = "Installer";
		this._icon = "/@skin@/styler/views/generators/install.svg";
		this._description = "Installer le dernier habillage graphique compilé";
		this._hideForStatuses = "failed,null";
		this.requireEnabledPerm("action.gen#install.genAsSkinPack")
	}

	async execute(ctx: IPubCtx, ev?: Event): Promise<any | 'noPreventDefault'> {
		try {
			let skinPack: JSkinPackInstalled = await new MsgOver().setCustomMsg("Veuillez patienter...", "info").showMsgOver(ctx.reg.env.uiRoot).waitFor(
				STYLER.installGenAsSkinpack(ctx.wsp, ctx.uiContext, SRC.srcRef(ctx.shortDesc), ctx.pubNode.codeGenStack, ctx.reg.env.uiRoot.lang)
			);
			if (skinPack) {
				POPUP.showNotifInfo("L'installation du skinpack s'est déroulée avec succès.\nVous pouvez maintenant l'utiliser (et l'activer) dans les ateliers concernés.", ctx.reg.env.uiRoot, {autoHide: 5000});
			} else
				throw "no skinpack";
		} catch (e) {
			return ERROR.report("L'installation du skinpack n'a pas pu aboutir", e);
		}

	}
}
